export function toHyphenCase(property: string): string {
  return property.includes('-')
    ? property
    : property.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
}
